'use client';

import React__default, { useState, useEffect } from 'react';
import Input from '../Input/index.js';
import { defaultPlaceholder, REGEXP_YYYY, REGEXP_MMYYYY, REGEXP_DDMMYYYY } from './const.js';
import { ELanguage } from '../Utils/constants.js';
import { getInputMaxlength, formatInputDate, isValidDateFormat } from './utils/index.js';
import { EDatePicker } from '../DatePicker/type.js';
import { useDidUpdateEffect } from '../Utils/hooks.js';

function DateInput(_a) {
    var _b = _a.type, type = _b === void 0 ? EDatePicker.date : _b, _c = _a.value, valueProps = _c === void 0 ? '' : _c, hasError = _a.hasError, onChangeProps = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, disabled = _a.disabled, _d = _a.langCode, langCode = _d === void 0 ? ELanguage.EN : _d, placeholder = _a.placeholder, min = _a.min, max = _a.max, isShowIcon = _a.isShowIcon, _e = _a.isPresent, isPresent = _e === void 0 ? false : _e;
    var _f = useState(valueProps || ''), inputValue = _f[0], setInputValue = _f[1];
    var onChange = function (value) {
        try {
            if (value) {
                var date = formatInputDate(value, type, 'Date');
                onChangeProps && onChangeProps(new Date(date));
                return;
            }
            onChangeProps && onChangeProps(null);
        }
        catch (error) {
            throw Error('Invalid date');
        }
    };
    var dateCheck = function (value) {
        if (!isPresent) {
            var isValid = isValidDateFormat(value, type);
            if (!isValid) {
                setInputValue('');
            }
            var date = formatInputDate(value, type, 'Date');
            var checkMinMax = (min && min > new Date(date)) || (max && max < new Date(date));
            if (isValid && checkMinMax) {
                setInputValue('');
            }
        }
    };
    var onInputChange = function (value) {
        if (!value) {
            onChangeProps && onChangeProps(null);
        }
        try {
            setInputValue(value);
            switch (type) {
                case EDatePicker.date:
                    // if (value.length === 2 && REGEXP_DD.test(value)) {
                    //     setInputValue(`${value}/`)
                    // }
                    // if (value.length === 5 && REGEXP_DDMM.test(value)) {
                    //     setInputValue(`${value}/`)
                    // }
                    if (REGEXP_DDMMYYYY.test(value)) {
                        onChange(value);
                    }
                    break;
                case EDatePicker.month:
                    // if (value.length === 2 && REGEXP_DD.test(value)) {
                    //     setInputValue(`${value}/`)
                    // }
                    if (REGEXP_MMYYYY.test(value)) {
                        onChange(value);
                    }
                    break;
                case EDatePicker.year:
                    if (REGEXP_YYYY.test(value)) {
                        onChange(value);
                    }
                    break;
                default:
                    break;
            }
        }
        catch (error) {
            throw Error('Invalid date');
        }
    };
    var onKeyDown = function (e) {
        if (e.key === 'Tab' || e.code === 'Tab') {
            dateCheck(inputValue);
            onBlur && onBlur(inputValue);
        }
    };
    useEffect(function () {
        setInputValue(valueProps || '');
    }, [valueProps]);
    useDidUpdateEffect(function () {
        if (!inputValue) {
            onChange(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputValue]);
    return (React__default.createElement(Input, { type: 'text', clearValue: isShowIcon, hasError: hasError, value: inputValue, onFocus: function (e) {
            var _a;
            onFocus && onFocus((_a = e.target) === null || _a === void 0 ? void 0 : _a.value, e);
        }, onBlur: function (e) {
            var _a, _b;
            dateCheck((_a = e.target) === null || _a === void 0 ? void 0 : _a.value);
            onBlur && onBlur((_b = e.target) === null || _b === void 0 ? void 0 : _b.value, e);
        }, onChange: onInputChange, onKeyDown: onKeyDown, placeholder: placeholder || defaultPlaceholder[type][langCode], disabled: disabled, maxLength: getInputMaxlength(type) }));
}
var DateInput$1 = React__default.memo(DateInput);

export { DateInput$1 as default };
//# sourceMappingURL=index.js.map
